import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import {reducer as reduxAsyncConnect} from 'redux-async-connect'
import {
  searchReducer as search,
  shareClassReducer as shareClass,
  companyReducer as company,
  companydetailsReducer as companydetails,
  tutorialdismissReducer as tutorialdismiss,
  compareReducer as compare,
  cartReducer as cart,
  searchCompaniesReducer as searchCompanies
} from './search'

export default combineReducers({
  routing: routerReducer,
  reduxAsyncConnect,
  search,
  shareClass,
  company,
  companydetails,
  tutorialdismiss,
  compare,
  cart,
  searchCompanies
})
